/**
 * Pure, framework-free helper that decides which texture key to use for an
 * entity visual. No Phaser import — fully testable in node.
 *
 * Callers (Entity.ts) do the actual Phaser side-effect; this just answers
 * "is there a loaded texture for this assetId?"
 */

export interface TextureLookup {
  getTexture(assetId: string): string | null;
}

/**
 * Returns the Phaser texture key to use for an entity, or null when the
 * assetId is absent or the texture has not been loaded yet (fall back to
 * the placeholder colour body).
 */
export function resolveEntityTexture(
  assetId: string | undefined,
  atlas: TextureLookup,
): string | null {
  if (!assetId) return null;
  return atlas.getTexture(assetId);
}
